import React, { FunctionComponent, useEffect, useRef, useState } from 'react';
import { Presentation } from './presentation';
import { usePrevious } from '../../../hooks/previous';

type Props = {
  q: string;
  isPage?: string;
  isReleasedRecruitmentsNone: boolean;
  targetEmploymentTypes: any;
  targetOccupations: any;
  targetOccupationDetails: any;
  occupationDetailsOccupationIds?: any;
  targetPrefectureDetails: any;
  handleChangeQ: (key: string, value: string) => void;
  handleSearch: (value: string) => void;
  handleOpenSp: () => void;
  handleModal?: () => void;
};

export const Component: FunctionComponent<Props> = (props) => {
  const [query, setQuery] = useState(props.q || '');
  const isMounted = useRef(false);

  const prevQ = usePrevious(props.q);

  useEffect(() => {
    if (isMounted.current) {
      if (props.q !== prevQ) {
        setQuery(props.q);
      }
    } else {
      isMounted.current = true;
    }
  }, [props.q, prevQ]);

  const handleChangeQ = (event: any) => {
    const target = $(event.currentTarget);
    const value = $(target).val();
    setQuery(value);
    props.handleChangeQ('q', value);
  };

  const handleSearch = () => {
    props.handleSearch('');
  };

  return (
    <Presentation
      q={query}
      isPage={props.isPage}
      isReleasedRecruitmentsNone={props.isReleasedRecruitmentsNone}
      targetEmploymentTypes={props.targetEmploymentTypes}
      targetOccupations={props.targetOccupations}
      targetOccupationDetails={props.targetOccupationDetails}
      targetPrefectureDetails={props.targetPrefectureDetails}
      handleChangeQ={handleChangeQ}
      handleSearch={handleSearch}
      handleOpenSp={props.handleOpenSp}
      handleModal={props.handleModal}
    />
  );
};
